import type { Sequence } from './types.tsx';

// For each value in the sequence we take the largest between existing and new.
// Additionally, we take either the new current value, or add the increment between new.current and new.before
// This increment approach helps us deal with race conditions where two update requests and sent ad the same time,
// and we may not process them here in order.
export const mergeWithIncrement = (existing: Sequence, newSequence: Sequence): Sequence => {
	const merged: Sequence = { ...existing };
	if (newSequence === undefined) {
		return merged;
	}

	// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
	for (const key of Object.keys(newSequence) as (keyof Sequence)[]) {
		const newValue = newSequence[key];
		const existingVal = merged[key];

		if (newValue !== undefined) {
			if (existingVal === undefined) {
				merged[key] = newValue;
			} else {
				const diffFromBE = newValue.before !== undefined ? newValue.current - newValue.before : 0;
				merged[key] = {
					...merged[key],
					current: Math.max(newValue.current, existingVal.current + diffFromBE),
				};
			}
		}
	}

	return merged;
};
